import { Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsString, ValidateNested, IsNumber } from "class-validator";
import GenericTableResponse from "@/models/api/GenericTableResponse";

export class Contractor {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  name!: string;
  @Expose()
  @IsString()
  tin!: string;
  @Expose()
  @IsBoolean()
  isLocked!: boolean;
  @Expose()
  @IsNumber()
  recordStampId!: number;
}

export class ContractorResponse extends GenericTableResponse<Contractor> {
  @Expose()
  @IsArray()
  @Type(() => Contractor)
  @ValidateNested()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<Contractor>;
}
